<template>
    <div class="dashboardCellMediationAdUnits">
        <div v-if="archived" class="archived font-7">N/A</div>
        <div v-else
             @mouseover="isHovering = true"
             @mouseout="isHovering = false">
            <div v-on:click="clickOnAdUnit(adUnit)" v-for="({ status }, adUnit) in adUnitStatus"
                 :key="`${appKey}_${adUnit}_${status}`"
                 class="adUnitWrapper"
                 :class="{'whiteBackground': isHovering }"
            >
<!--                <Tooltip :text="`Manage Ad Unit ${adUnitTOName[adUnit]}`"-->
                <div
                         class="adUnitIcon"
                >
                        <IconBase height="24"
                                  width="14"
                                  :iconName="`${adUnit}Icon`"
                                  :iconColor="getAdUnitColor(status)" />
<!--                </Tooltip>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import Tooltip from 'components/Tooltip/Tooltip.vue';

const ACTIVE_STATUS = 'active';

export default {
    name: 'DashboardCellMediationAdUnits',
    components: { Tooltip, IconBase },
    data() {
        return {
            adUnitTOName: consts.ADUNIT_TO_NAME,
            isHovering: false
        };
    },
    props: {
        adUnitStatus: Object,
        archived: Boolean,
        appKey: String
    },
    methods: {
        getAdUnitColor(status) {
            return status === ACTIVE_STATUS ? consts.COLORS.PRIMARY_500 : consts.COLORS.LIGHT_700;
        },
        clickOnAdUnit(adUnit) {
            const adUnitName = consts.ADUNIT_TO_SHORT_NAME[adUnit] || '';
            this.$emit('adUnitClicked', { appKey: this.appKey, adUnit: adUnitName });
        }
    }
};
</script>

<style scoped>
</style>
